import { render, staticRenderFns } from "./ShowList.vue?vue&type=template&id=101d96d3&scoped=true&"
import script from "./ShowList.vue?vue&type=script&lang=ts&"
export * from "./ShowList.vue?vue&type=script&lang=ts&"
import style0 from "./ShowList.vue?vue&type=style&index=0&id=101d96d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101d96d3",
  null
  
)

export default component.exports